import { useQuery } from 'react-query';

import { POINT_QUERY_KEY } from '~/api/query-keys/point';

export type { BuyerPoint } from '~/api/model/point';

/** 보유 포인트 및 발급 가능한 포인트 쿠폰 조회 */
// GET /api/market-place/v1/buyer/point
export const useBuyerPoint = () => {
  const { queryKey, queryFn } = POINT_QUERY_KEY.buyerPoint();

  return useQuery(queryKey, queryFn, {
    suspense: true,
  });
};
